module.exports = __webpack_public_path__ + "img/panda_1.6b567a56.png";